var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.75C3.6565 1.75 1.75 3.6565 1.75 6C1.75 8.3435 3.6565 10.25 6 10.25C8.3435 10.25 10.25 8.3435 10.25 6C10.25 3.6565 8.3435 1.75 6 1.75ZM6 11C3.243 11 1 8.757 1 6C1 3.243 3.243 1 6 1C8.757 1 11 3.243 11 6C11 8.757 8.757 11 6 11Z",
    fill: "#999FA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71557 7.84635C7.65007 7.84635 7.58407 7.82935 7.52357 7.79385L5.63857 6.66935C5.52557 6.60135 5.45557 6.47885 5.45557 6.34685V3.92285C5.45557 3.71585 5.62357 3.54785 5.83057 3.54785C6.03807 3.54785 6.20557 3.71585 6.20557 3.92285V6.13385L7.90807 7.14885C8.08557 7.25535 8.14407 7.48535 8.03807 7.66335C7.96757 7.78085 7.84307 7.84635 7.71557 7.84635Z",
    fill: "#999FA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.637736e7402b759743862f531e6a62a9.svg";
export { ForwardRef as ReactComponent };